import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  column-gap: 1rem;
  display: flex;
  flex-wrap: wrap;
`;
